import { propType } from '../../../../node_modules/@styled-system/prop-types';

export default { textTransform: propType };